import { Injectable }             from '@angular/core';
import { Headers, Http, Response} from '@angular/http';
import { Router }                 from '@angular/router';
import { NotificationsService }   from 'angular2-notifications';
import { OAuthService }           from 'angular-oauth2-oidc';

import { environment }            from '../../environments/environment';
import { UserService }            from '../services'
import { Group, Organisation }    from '../models';

import 'rxjs/add/operator/toPromise';
import 'file-saver';

var FileSaver = require('file-saver');

@Injectable()
export class CtlService {
  private ctlUrl = environment.ctlUrl;
  private exportUrl = environment.exportUrl;

  constructor(private http: Http, private authService: OAuthService, private router: Router, private notificationsService: NotificationsService, private userService: UserService) {
  }

  getOrganisations(): Promise<Organisation[]>{
    return this.http
      .get(this.ctlUrl + '/organisations?per_page=2000', {headers: this.createHeaders()})
      .toPromise()
      .then((response: Response) => response.json())
      .then((organisations) => organisations.map(({name, id}) => new Organisation(id, name)))
      .catch((error) => this.handleError(error));
  }

  getGroups(organisation: Organisation): Promise<Group[]> {
    return this.http
      .get(this.ctlUrl + '/organisations/' + organisation.id +'/groups?per_page=2000', {headers: this.createHeaders()})
      .toPromise()
      .then((response: Response) => response.json())
      .then((groups) => groups.map(({id, organisation_id, name}) => new Group(id,organisation_id, name)))
      .catch((error) => this.handleError(error));
  }

  getExport(organisation: Organisation, group: Group = null): Promise<any> {
    let fullUrl = this.exportUrl + '/organisations/' + organisation.id;
    let fileName = group ? group.name : organisation.name;

    if (group) {
      fullUrl += '/groups/' + group.id;
    };
    fullUrl += '/devices.csv';

    return this.http
      .get(fullUrl, {headers: this.createHeaders()})
      .toPromise()
      .then((data: any) => this.downloadFile(data, fileName))
      .catch((error) => this.handleError(error));
  }

  getGatewayExport(organisation: Organisation, group: Group = null): Promise<any> {
    let fullUrl = this.exportUrl + '/organisations/' + organisation.id;
    let fileName = group ? group.name : organisation.name;

    if (group) {
      fullUrl += '/groups/' + group.id;
    };
    fullUrl += '/gateways.csv';

    return this.http
      .get(fullUrl, {headers: this.createHeaders()})
      .toPromise()
      .then((data: any) => this.downloadFile(data, fileName))
      .catch((error) => this.handleError(error));
  }

  downloadFile(data: Response, fileName: String): void {
    let blob = new Blob([(<any>data)._body], { type: 'text/csv' });
    FileSaver.saveAs(blob, fileName+".csv");
  }

  private createHeaders(): Headers {
    let headers = new Headers({'Content-Type': 'application/json'});
    headers.append('Authorization', this.authService.authorizationHeader());
    return headers;
  }

  private handleError(error: any): void{
    if (error && error.status == 401) {
      this.notificationsService.error("Unauthorized", "The token has expired or is invalid. Please log in.");
      this.authService.logOut(true);
      this.userService.changeUser(null);
      this.router.navigate(['/']);
    } else {
      this.notificationsService.error(error.status, "The server responded with a: " + error.status);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/ctl.service.ts